window.axios = require('axios/index');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

import Global from './general/global';
import Nav from './general/nav';
import Home from './pages/home';
import Category from "./pages/category";
import Product from './pages/product';
import AddToCart from "./general/addtocart";
import Cart from "./pages/cart";
import Order from "./pages/order";
import Account from "./pages/account";
import ModelSearch from "./general/modelsearch";

// General
new Nav();
new Global();
new AddToCart();
new ModelSearch()

// Pages
new Home();
new Product();
new Category();
new Cart();
new Order();
new Account();
